import React from 'react';
import {Nav} from 'react-bootstrap';
import {NavLink} from 'react-router-dom';

export default function Footer() {
  return (
    <div>
      <footer id="theme-bg" className="text-center text-lg-start text-light">
        <div className="container p-4">

          <div className="row">
            <div className="col-lg-6 col-md-12 mb-4 mb-md-0 pr-2 text-md-center text-lg-left">
              <h5 className="text-uppercase">About</h5>
              <p>
                We noticed that most entrepreneurs had very little idea whether customers would pay for sustainable products.
                So, we built this forum to get consumers' sustainability ideas to businesses.
                Sadly, most consumers weren't interested in this idea. But we left this forum online for the few that were :-)
              </p>
              <p>
              - <a className="theme-link" href="https://www.linkedin.com/in/paige-gugeler-0273a6175/" target="_blank" rel="noopener noreferrer">Paige Gugeler</a>, <a className="theme-link" href="https://www.linkedin.com/in/aryan-saha-0190541a0/" target="_blank" rel="noopener noreferrer">Aryan Saha</a>, and <a className="theme-link" href="http://madhavmalhotra.com/" target="_blank" rel="noopener noreferrer">Madhav Malhotra</a>.
              </p>
            </div>

            <div className="col-lg-6 col-md-12 mb-4 mb-md-0">
              <h5 className="text-uppercase">Links</h5>

              <ul className="list-unstyled mb-0">
                <li>
                  <Nav.Link as={NavLink} to="/forum" className="theme-link">Forum</Nav.Link>
                </li>
                <li>
                  <Nav.Link className="theme-link" onClick={() => window.open("https://forms.gle/SugKsKSfFsVTS4Wc8")}>Bugs</Nav.Link>
                </li>
              </ul>
            </div>

            <div className="col-12 mt-5 text-center">
              Copyright 2021
            </div>
            
          </div>
        </div>
      </footer>
    </div>
  )
}
